module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Bookmark-ab19c27707858c5964bf8299daebe9f3.svg";